import React from 'react';
import Header from "../Component/Header/Header";
import {Outlet} from "react-router-dom";
import Footer from '../Component/Footer/Footer'

const Sitelayout = () => {
	return (
		<>
			<Header />
			<Outlet />
			<Footer />
		</>
	);
};

export default Sitelayout;